import { useApiCache } from './useApiCache';

interface MenuItem {
  id: number;
  name: string;
  route: string | null;
  icon: string | null;
  parent_id: number | null;
  sort_order: number;
  is_active: boolean;
  roles: string[];
  children?: MenuItem[];
}

export const useMenuData = () => {
  const fetchMenuData = async (): Promise<MenuItem[]> => {
    const token = localStorage.getItem('auth_token');
    
    const response = await fetch('/api/menu-management/user-menu', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });


    if (response.ok) {
      const data = await response.json();

      // Güvenli length kontrolü - data'nın array olup olmadığını kontrol et
      if (Array.isArray(data)) {
        return data;
      } else {
        console.warn('useMenuData: API returned non-array data:', data);
        // Eğer data array değilse, boş array döndür
        return [];
      }
    } else {
      const errorText = await response.text();
      console.error('useMenuData: API error:', response.status, errorText);
      console.error('useMenuData: Response headers:', Object.fromEntries(response.headers.entries()));
      throw new Error(`Menü verileri alınamadı: ${response.status}`);
    }
  };

  const { data, loading, error, refetch, invalidateCache, clearAllCache } = useApiCache<MenuItem[]>(
    'menu-data',
    fetchMenuData,
    { ttl: 30000 } // 30 seconds cache - daha kısa süre
  );

  return {
    menuItems: Array.isArray(data) ? data : [], // Güvenli array kontrolü
    loading,
    error,
    refetch,
    invalidateCache,
    clearAllCache
  };
};